<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title class="title">
      {{ 'LIB_ORDERS.COMMON.ORDER_CURRENCY.TITLE' | translate }}
      <va-badge color="gray">
        <span>{{ 'LIB_ORDERS.COMMON.ORDER_CURRENCY.VMF_ONLY_BADGE' | translate }}</span>
      </va-badge>
    </mat-card-title>
    <mat-card-subtitle>
      {{ 'LIB_ORDERS.COMMON.ORDER_CURRENCY.DESCRIPTION' | translate }}
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <mat-form-field class="currency-selector">
      <mat-select [(value)]="selectedCurrency">
        <mat-option value="">
          {{ 'LIB_ORDERS.COMMON.ORDER_CURRENCY.DEFAULT_OPTION' | translate }}
        </mat-option>
        <mat-option *ngFor="let currency of allCurrencies" [value]="currency">
          {{ currency }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-card-content>
</mat-card>
